import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { LazyLoadingService } from '../../../core/services/lazy-loading.service';

@Component({
  selector: 'app-lazy-loading',
  standalone: true,
  imports: [AsyncPipe, LoadingSpinnerComponent],
  templateUrl: './lazy-loading.component.html',
  styleUrl: './lazy-loading.component.scss',
})
export class LazyLoadingComponent {
  lazyLoadingService = inject(LazyLoadingService);
}
